/**
 * Sepet sözleşme onayı.
 * Horizon sepeti güncellerken içeriği yeniden çizer (morph) ve içerideki <script>'ler çalışmaz;
 * bu yüzden mantık burada, çekmecenin dışında ve olay delegasyonuyla kurulur.
 * - Onay kutusu işaretlenmeden ödeme butonu pasif görünür ve tıklama engellenir.
 * - Onay durumu oturum boyunca hatırlanır (sepet yenilense de kaybolmaz).
 */
(() => {
  const KEY = 'zv-consent';
  const read = () => {
    try {
      return sessionStorage.getItem(KEY) === '1';
    } catch (e) {
      return false;
    }
  };
  const write = (value) => {
    try {
      sessionStorage.setItem(KEY, value ? '1' : '0');
    } catch (e) {
      /* tarayıcı depolamayı engelliyorsa yalnızca sayfa içinde tutulur */
    }
  };
  let accepted = read();

  const sync = () => {
    const boxes = document.querySelectorAll('[data-zv-consent]');
    const required = boxes.length > 0;
    boxes.forEach((box) => {
      const input = box.querySelector('[data-zv-consent-input]');
      if (input && input.checked !== accepted) input.checked = accepted;
      if (box.classList.contains('is-ok') !== accepted) box.classList.toggle('is-ok', accepted);
    });
    document.querySelectorAll('.cart__checkout-button').forEach((btn) => {
      const block = required && !accepted;
      // Yalnızca değer değişiyorsa yaz: aksi halde gözlemci kendi değişikliğimizi yakalayıp döngüye girer
      const has = btn.getAttribute('aria-disabled') === 'true';
      if (block && !has) btn.setAttribute('aria-disabled', 'true');
      else if (!block && has) btn.removeAttribute('aria-disabled');
    });
  };

  const alertUser = (from) => {
    const scope = from?.closest('.cart__ctas, .cart-drawer__summary, form, body') || document;
    const box = scope.querySelector('[data-zv-consent]') || document.querySelector('[data-zv-consent]');
    if (!box) return;
    box.classList.remove('is-alert');
    void box.offsetWidth; // animasyonu yeniden başlat
    box.classList.add('is-alert');
    box.querySelector('[data-zv-consent-input]')?.focus();
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-zv-consent-input]')) return;
    accepted = event.target.checked;
    write(accepted);
    sync();
  });

  // Ödemeye geçişi yakala (buton, form gönderimi ve Enter tuşu)
  const guard = (event) => {
    if (accepted || !document.querySelector('[data-zv-consent]')) return;
    const target = event.type === 'submit' ? event.submitter : event.target.closest?.('.cart__checkout-button');
    if (event.type === 'submit') {
      const isCheckout = target?.name === 'checkout' || event.target.querySelector?.('[name="checkout"]') === document.activeElement;
      if (!isCheckout) return;
    } else if (!target) {
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    alertUser(target || event.target);
  };
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);

  // Sepet yeniden çizildiğinde durumu geri uygula
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      sync();
    });
  };
  const start = () => {
    sync();
    new MutationObserver((records) => {
      for (const r of records) {
        for (const n of r.addedNodes) {
          if (n.nodeType === 1 && (n.matches?.('[data-zv-consent], .cart__checkout-button') || n.querySelector?.('[data-zv-consent], .cart__checkout-button'))) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    // Horizon sepeti güncellerken mevcut kutunun "checked" özelliğini sunucudaki (boş) haline
    // eşitleyebilir; bu bir DOM değişikliği üretmez. Kutu sayfadayken durumu hafifçe yeniden uygula
    // (sync değişiklik yoksa hiçbir şey yazmaz).
    setInterval(() => {
      if (document.querySelector('[data-zv-consent]')) sync();
    }, 600);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
